/* eslint-disable quotes */
export const AbrExampleByAbn = {
    "SearchByABNv201408Response": {
        "result": "SearchByABNv201408Result",
        "SearchByABNv201408Result": {
            "@id": "id1",
            "Request": {
                "@id": "id2",
                "ExternalRequestBody": {
                    "@id": "id3",
                    "AuthenticationGUID": "e9959e02-eccd-40c6-be26-7d1a19267b95",
                    "IdentifierType": "ABN",
                    "IdentifierValue": 37552837401,
                    "History": "N"
                }
            },
            "Response": {
                "@id": "id4",
                "UsageStatement": "The Registrar of the ABR monitors the quality of the information available on this website and updates the information regularly. However, neither the Registrar of the ABR nor the Commonwealth guarantee that the information available through this service (including search results) is accurate, up to date, complete or accept any liability arising from the use of or reliance upon this site.",
                "DateRegisterLastUpdated": "2023-09-12T00:00:00",
                "DateTimeRetrieved": "2023-09-12T00:32:49.6835931+10:00",
                "ResponseBody": {
                    "@id": "id5",
                    "RecordLastUpdatedDate": "2022-12-11T00:00:00",
                    "ABN": {
                        "@id": "id6",
                        "@itemType": "types:Identifier",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id7",
                            "IdentifierValue": 37552837401,
                            "IsCurrentIndicator": "Y",
                            "ReplacedFrom": "0001-01-01T00:00:00"
                        }
                    },
                    "EntityStatus": {
                        "@id": "id8",
                        "@itemType": "types:EntityStatus",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id9",
                            "EntityStatusCode": "Active",
                            "EffectiveFrom": "2013-03-18T00:00:00",
                            "EffectiveTo": "0001-01-01T00:00:00"
                        }
                    },
                    "ASICNumber": "",
                    "EntityType": {
                        "@id": "id10",
                        "EntityTypeCode": "SGE",
                        "EntityDescription": "State Government Entity"
                    },
                    "GoodsAndServicesTax": {
                        "@id": "id11",
                        "@itemType": "types:GoodsAndServicesTax",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id12",
                            "EffectiveFrom": "2013-03-18T00:00:00",
                            "EffectiveTo": "0001-01-01T00:00:00"
                        }
                    },
                    "Name": {
                        "@id": "id13",
                        "@itemType": "xsd:anyType",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id14",
                            "OrganisationName": "SERVICE NSW",
                            "EffectiveFrom": "2014-02-24T00:00:00"
                        }
                    },
                    "MainBusinessPhysicalAddress": {
                        "@id": "id15",
                        "@itemType": "types:AddressDetails",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id16",
                            "StateCode": "NSW",
                            "Postcode": 2000,
                            "EffectiveFrom": "2018-11-01T00:00:00",
                            "EffectiveTo": "0001-01-01T00:00:00"
                        }
                    },
                    "BusinessName": {
                        "@id": "id17",
                        "@itemType": "types:OrganisationName",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id18",
                            "OrganisationName": "Specialized Coatingz",
                            "EffectiveFrom": "2022-12-11T00:00:00"
                        }
                    }
                }
            }
        }
    }
};
